module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 33
// module chunks = 0